import { render, staticRenderFns } from "./WorldBabylon.vue?vue&type=template&id=39041f84&"
import script from "./WorldBabylon.vue?vue&type=script&lang=js&"
export * from "./WorldBabylon.vue?vue&type=script&lang=js&"
import style0 from "./WorldBabylon.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports